import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/auth/password-resets/verify/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const verify = {
  post: apiPathFunc(pathBase),
};
